/*
** TODO: specifically for IE
 */
import 'es6-promise/auto';
import 'mdn-polyfills/Object.keys';
import 'mdn-polyfills/Number.isInteger';
import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Array.prototype.includes';
import 'mdn-polyfills/Array.prototype.findIndex';

import 'moment-timezone';
import 'moment-countdown';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-slider-component/theme/default.css';
import 'material-design-icons/iconfont/material-icons.css';

import './validator';
import './assets/styles.scss';
import { SocialsService } from './common/services/socials/socials.service';

import PortalVue from 'portal-vue';
import Fragment from 'vue-fragment';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import VueQuillEditor from 'vue-quill-editor';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import Vue from 'vue';
import App from './App';
import router from './router';
import filters from './filters';
import store from './store/store';

Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.use(VueQuillEditor);
Vue.use(Fragment.Plugin);
Vue.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA_SITE_KEY
});
Vue.use(VeeValidate, {
    events: 'input'
});

Vue.config.productionTip = false;

export const SCHOOL_APP = new Vue({
    el: '#app',
    router,
    store,
    filters,
    components: { App },
    template: '<App/>',
    created: () => {
        SocialsService.initFacebook();
        SocialsService.initTwitter();
    }
});


// WEBPACK FOOTER //
// ./src/main.js